export const addtocart = "addtocart";
export const removeItem = "removeItem"
export const check = "check"
export const lengthTell = "lengthTell"
